export enum COUPON_LIMIT {
  Limited = 'Limitado',
  Unlimited = 'Ilimitado',
}

export enum COUPON_TYPE {
  Store = 'Loja',
  Signature = 'Assinatura',
}
